import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import { AutenticacaoModule } from "src/Contexto/auth";
import {
  FormatarCEP,
  FormatarCNPJ,
  MapearErrosServidor,
  MapearErrosServidorCampo,
  SoNumeros,
} from "src/hook/Functions";
import {
  EmpresaAtualizar,
  EmpresaBuscarPorUsuario,
  EmpresaIncluir,
} from "src/services/Entidade.Service";
import { BuscarCep } from "src/services/ViaCEP";
import {
  EmpresaDto,
  EmpresaSchema,
} from "../../Entidade/Empresa/Empresa.Dto";
import {
  getCadastroInicialLocal,
  setCadastroInicialLocal,
  setPendenteCadastroUsuario,
  STORAGE_CADASTRO_INICIAL_EMPRESA,
} from "../CadastroInicial.Dto";

export const CadastroInicialEmpresaCode = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { empresaId, userId, refreshToken } = AutenticacaoModule();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue,
    getValues,
  } = useForm<EmpresaDto>({
    resolver: yupResolver(EmpresaSchema),
    defaultValues: undefined,
  });

  useEffect(() => {
    const Load = async () => {
      if (empresaId > 0) {
        setLoading(true);
        try {
          const response = await EmpresaBuscarPorUsuario();
          if (response.data?.success && response.data?.data) {
            const data = response.data.data;
            data.documento = FormatarCNPJ(data.documento);
            data.cep = FormatarCEP(data.cep);
            reset(data);
          }
        } catch (e) {
          console.error("Erro ao carregar empresa existente:", e);
        } finally {
          setLoading(false);
        }
      } else {
        const saved = getCadastroInicialLocal<EmpresaDto>(
          STORAGE_CADASTRO_INICIAL_EMPRESA
        );
        if (saved) {
          saved.documento = FormatarCNPJ(saved.documento);
          saved.cep = FormatarCEP(saved.cep);
          reset(saved);
        }
      }
    };
    Load();
  }, [empresaId, reset]);

  const buscarCep = (cep: string) => {
    if (SoNumeros(cep).length === 8) {
      BuscarCep(cep)
        .then((response: any) => {
          if (response && !response.erro) {
            const current = getValues();

            if (
              (!current.bairro || current.bairro.trim() === "") &&
              response.bairro
            ) {
              setValue("bairro", response.bairro);
            }
            if (
              (!current.endereco || current.endereco.trim() === "") &&
              response.logradouro
            ) {
              setValue("endereco", response.logradouro);
            }
            if (
              (!current.nomeMunicipio || current.nomeMunicipio.trim() === "") &&
              response.localidade
            ) {
              setValue("nomeMunicipio", response.localidade);
            }
            if (
              (!current.codigoMunicipio ||
                current.codigoMunicipio.toString().trim() === "") &&
              response.ibge
            ) {
              setValue("codigoMunicipio", response.ibge.toString());
            }
            if ((!current.uf || current.uf.trim() === "") && response.uf) {
              setValue("uf", response.uf);
            }
          }
        })
        .catch((err) => {
          console.error("Erro ao buscar CEP:", err);
        });
    }
  };

  const onSubmit = async (data: EmpresaDto, e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      const empresaPayload: EmpresaDto = {
        ...data,
        cep: SoNumeros(data.cep),
        documento: SoNumeros(data.documento),
        codigoRegimeTributario: Number(data.codigoRegimeTributario),
      };

      let resEmpresa;
      if (empresaId > 0) {
        resEmpresa = await EmpresaAtualizar(empresaPayload);
      } else {
        try {
          const checkEmpresa = await EmpresaBuscarPorUsuario();
          if (checkEmpresa.data?.success && checkEmpresa.data?.data) {
            resEmpresa = await EmpresaAtualizar(empresaPayload);
          } else {
            resEmpresa = await EmpresaIncluir(empresaPayload);
          }
        } catch {
          resEmpresa = await EmpresaIncluir(empresaPayload);
        }
      }

      if (!resEmpresa.data?.success) {
        MapearErrosServidorCampo(resEmpresa.data?.notifications, setError);
        MapearErrosServidor(resEmpresa.data?.notifications, showToast);
        showToast({
          message:
            resEmpresa.data?.notifications?.[0]?.message ||
            "Ocorreu um erro ao salvar os dados da empresa.",
          title: "Erro no cadastro da empresa",
          variant: "Danger",
        });
        return;
      }

      setCadastroInicialLocal(STORAGE_CADASTRO_INICIAL_EMPRESA, data);
      setPendenteCadastroUsuario(userId);

      await refreshToken();

      showToast({
        message: "Empresa cadastrada com sucesso!",
        title: "Sucesso",
        variant: "Success",
      });

      navigate("/cadastro-inicial/usuario");
    } catch (error) {
      console.error("Erro ao processar cadastro da empresa:", error);
      showToast({
        message: "Ocorreu um erro ao processar o cadastro da empresa.",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    register,
    handleSubmit,
    errors,
    onSubmit,
    setValue,
    getValues,
    buscarCep,
  };
};

export default CadastroInicialEmpresaCode;

